import { render, staticRenderFns } from "./ResellerCommission.vue?vue&type=template&id=caf6a05a&"
import script from "./ResellerCommission.vue?vue&type=script&lang=js&"
export * from "./ResellerCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports